import React from "react";
import { VariantProps } from ".";
import ChatLink from "./ChatLink";
import GoogleViewPrice from "../GoogleViewPrice";
import WhyWeDoThis from "./WhyWeDoThis";
import StandardPrice from "../StandardPrice";
import PlusShippingLevels from "../PlusShippingLevels";
import ContactUsForDetails from "./ContactUsForDetails";
import CreditKeyBanner from "~/ProductDetails/CreditKey/CreditKeyBanner";
import getPriceForGoogleView from "../getPriceForGoogleView";
const F = (props: VariantProps) => {
  const {
    price,
    user,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isGoogleView,
    isWebstaurantPlusEligible,
    minimumBuy,
    mustBuy,
    unitOfMeasure,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers
  } = props;
  const {
    registered,
    hasWebPlus,
    platinum,
    analyticsData
  } = user;
  const displayPrice = registered && (hasWebPlus || platinum.enabled || Number(analyticsData.total_orders) >= 2) ? price.minimumAdvertisedPriceProperties.price : price.price;
  const creditKeyPrice = isGoogleView ? getPriceForGoogleView({
    price: displayPrice,
    minimumBuy,
    mustBuy
  }) : displayPrice;
  return (
    // style names and MAP styles are intentionally mismatched
    <div className="map map-override mapL" data-sentry-component="F" data-sentry-source-file="F.tsx">
      {isGoogleView || registered ? <>
          <div className="map__group">
            <ChatLink className="map__text map__link">
              <>
                <p className="text__highlight">Lowest Price Guarantee</p>
                <p className="text__small">
                  {"Chat Now "}
                  <i className="icon-breadcrumb" />
                </p>
              </>
            </ChatLink>
            <div className="map__price">
              <label className="price__label">Retail Price</label>
              {isGoogleView ? <GoogleViewPrice price={displayPrice} minimumBuy={minimumBuy} mustBuy={mustBuy} showCreditKey={false} /> : <StandardPrice price={displayPrice} unitOfMeasure={unitOfMeasure} showCreditKey={false} />}
            </div>
          </div>
          <CreditKeyBanner price={creditKeyPrice} />
          <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} />
          {!price.hideWhyDoWeDoThis && <WhyWeDoThis type="contact" />}
        </> : <>
          <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} />
          <ContactUsForDetails loginOverride={showBelowMinimumAdvertisedPriceForLoggedInCustomers} />
          <p className="to-see-price noborder mb-2">
            <ChatLink />
            <em>
              (Mon-Fri 8AM-8PM EST
              <br />
              Sat &amp; Sun: 9am - 4pm EST)
            </em>
          </p>
          {!price.hideWhyDoWeDoThis && <WhyWeDoThis type="contact" />}
        </>}
    </div>
  );
};
export default F;